import React from "react";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";

const PasswordManagerHeader = () => {
    const { t: tLang } = useTranslation();

    return (
        <React.Fragment>
            <div className="box-header">
                <div className="box-title-container">
                    <div className="box-title-icon" aria-hidden="true">
                        <RenderIcons iconName="key" />
                    </div>
                    <div className="box-title-text">
                        <h2 className="box-title">{tLang("identityVault.passwordManager.tabTitle")}</h2>
                    </div>
                </div>
                <div className="box-description">
                    <p>{tLang("identityVault.passwordManager.description")}</p>
                </div>
            </div>
        </React.Fragment>
    );
};

export default PasswordManagerHeader;
